// TypeScriptの型定義を拡張する
declare global {
  interface Array<T> {
    insertBetweenElements(element: T): T[];
  }
}

// 配列の拡張関数
Array.prototype.insertBetweenElements = function <T>(this: T[], element: T): T[] {
  let resultArray: T[] = [];
  for (let i = 0; i < this.length - 1; i++) {
    resultArray.push(this[i]);
    resultArray.push(element);
  }
  resultArray.push(this[this.length - 1]);
  return resultArray;
};

export {};
